import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../../fetch'
import {
  baseURL,
  commonHeaders,
} from './../../../../../Containers/Confiq/index'

import {
  UPDATE_SERVICE,
  UPDATE_SERVICE_SUCCESS,
  UPDATE_SERVICE_ERROR,
} from './../../../actionType'

function* updateService({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `${baseURL}/parse/classes/golfbookings/${payload.id}`,
      method: 'GET',
      headers: { ...commonHeaders },
    })

    console.log('mytestingResponse', response, response?.error)
    if (response?.error === undefined) {
      yield put({ type: UPDATE_SERVICE_SUCCESS, payload: response })
    } else {
      yield put({ type: UPDATE_SERVICE_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: UPDATE_SERVICE_ERROR, payload: error })
  }
}

export function* watchUpdateService() {
  yield takeEvery(UPDATE_SERVICE, updateService)
}

function* updateServiceSaga() {
  yield all([fork(watchUpdateService)])
}

export default updateServiceSaga
